import React from "react";
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";

// Branded shell shared by every learner auth screen (register / login / forgot /
// set-password). Reuses the app's existing auth wrapper classes so it inherits
// the eC-Card auth look, with an `.lms-auth-*` layer for LMS-specific chrome.
const LearnerAuthShell = ({
  title,
  heading,
  headingExtra,
  subheading,
  organisation,
  children,
  footer,
}) => {
  const { t } = useTranslation();
  const orgName = organisation?.name || organisation?.orgName || "";
  const orgLogoSrc = organisation?.brandLogoUrl || "";
  // Auth pages live at different route depths (login, forgot-password and
  // tokenised set/reset-password links). An absolute public-asset URL keeps the
  // eC-Card logo stable on every one of those routes.
  // const ecLogoSrc = "/assets/icons/eC-Card-Logo.svg";
  const brandFallback = t("learner.lms.brand", "ESHS Learning");
  const pageTitle = title
    ? `${title} - ${orgName || brandFallback}`
    : orgName || brandFallback;

  return (
    <>
      <Helmet>
        <title>{pageTitle}</title>
      </Helmet>
      <div className="auth-screen-wrapper">
        <div className="fix-width-wrapper-lms px-3 mx-auto">
          <div className="auth-body-wrapper">
            <div className="logo-wrapper lms-auth-brand text-center">
              <div className="lms-auth-brand-row">
                {/* <img
                  src={ecLogoSrc}
                  alt="eC-Card"
                  className="logo lms-auth-ec-logo"
                /> */}
                {(orgLogoSrc || orgName) && (
                  <>

                    <div className="">
                      {orgLogoSrc && (
                        <img
                          src={orgLogoSrc}
                          alt={orgName || t("learner.lms.shell.orgLogoAlt", "Learning organisation")}
                          className="logo lms-auth-org-logo"
                        />
                      )}

                    </div>
                  </>
                )}
              </div>
            </div>
            {headingExtra && <div className="lms-auth-heading-extra">{headingExtra}</div>}
            {heading && <h1 className="lms-auth-title">{heading}</h1>}
            {subheading && <p className="lms-auth-sub">{subheading}</p>}
            <div className="px-4 pb-4">{children}</div>
            {footer && <div className="lms-auth-footer">{footer}</div>}
          </div>
        </div>
      </div>
    </>
  );
};

export default LearnerAuthShell;
